import { render } from "./JournalTabDiagnostic.vue?vue&type=template&id=58c73e04&scoped=true"
import script from "./JournalTabDiagnostic.vue?vue&type=script&lang=js"
export * from "./JournalTabDiagnostic.vue?vue&type=script&lang=js"

import "./JournalTabDiagnostic.vue?vue&type=style&index=0&id=58c73e04&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c73e04"]])

export default __exports__